module.exports = ".icon-space {\n  padding-left: 10px; }\n\nag-grid-angular {\n  margin: 1% 5%; }\n\n.ag-header-cell {\n  width: 14% !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin-provider-county/admin-provider-county.component.scss
// module id = ./src/app/admin-provider-county/admin-provider-county.component.scss
// module chunks = main